import { Box, Typography } from "@mui/material";
import FolderOffIcon from "@mui/icons-material/FolderOff";

type Props = {
    title: string;
    subtitle: string;
};

const EmptyDataDocs = ({ title, subtitle }: Props): JSX.Element => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            py={8}
            px={2}
            color="text.secondary"
        >
            <FolderOffIcon sx={{ fontSize: 60, color: "#b0b0b0", mb: 2 }} />
            <Typography variant="h6" fontWeight={600} gutterBottom>
                {title}
            </Typography>
            <Typography variant="body2">{subtitle}</Typography>
        </Box>
    );
};

export default EmptyDataDocs;
